/**
 * Utility for scrolling to inline citations from the References section.
 * EVI-385: Enables reference → citation linking.
 */

import { CITATION_OPEN_EVENT } from './CitationBadge';

/** Delay before opening popover (allows scroll to complete) */
const OPEN_POPOVER_DELAY_MS = 300;

/**
 * Scrolls to the first inline citation badge matching the given URL
 * and opens its popover to highlight which source was referenced.
 *
 * @param url - The source URL to find in the inline citations
 * @returns true if a citation was found and scrolled to, false otherwise
 */
export const scrollToInlineCitation = (url: string): boolean => {
  // Find the first citation badge with matching URL
  const citationElement = document.querySelector<HTMLElement>(
    `[data-citation-url="${CSS.escape(url)}"]`
  );

  if (!citationElement) {
    return false;
  }

  // Scroll the element into view with smooth animation
  citationElement.scrollIntoView({
    behavior: 'smooth',
    block: 'center',
    inline: 'nearest',
  });

  // After scroll completes, dispatch event to open the popover
  setTimeout(() => {
    citationElement.dispatchEvent(new CustomEvent(CITATION_OPEN_EVENT));
  }, OPEN_POPOVER_DELAY_MS);

  return true;
};
